import { EventLabel, InteractionEvent, InteractionGoal } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';
import { isPlatformHg } from '@/helpers/platformDetection';

const AUTH_LOGIN_EVENT_ACTION = 'auth_login';

export function trackGoogleOneTapImpression(): void {
  trackEventHarmonized(InteractionEvent.FEATURE_DISPLAYED, {
    h_event_category_006: InteractionEvent.FEATURE_DISPLAYED,
    h_event_action_007: InteractionGoal.DISPLAY_LOGIN_MODAL,
    h_event_label_008: EventLabel.GOOGLE_ONE_TAP,
  });
}

export function trackGoogleOneTapLoginSuccess(userId: string): void {
  trackEventHarmonized(InteractionEvent.AUTHENTICATION, {
    h_event_category_006: InteractionEvent.AUTHENTICATION,
    h_event_action_007: AUTH_LOGIN_EVENT_ACTION,
    h_client_login_user_id_036: userId, // auth0 userId
    h_client_login_provider_034: 'google', // apple, google, email, passkey, undefined
    h_login_location_049: EventLabel.GOOGLE_ONE_TAP,
    h_event_label_008: isPlatformHg() ? 'homegate_web' : 'immoscout24_web', // referring platform
    h_login_status_035: 'loggedin',
  });
}
